import localData from "kuan-utils/lib/localData";

const key = "invitation_app";

export default localData.create(key);
